module.exports = __webpack_public_path__ + "img/gift-decor.249351ae.png";